import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
} from '@app/infrastructure/models/form/form';
import {
  ITextAreaField,
  TextAreaField,
} from '@app/infrastructure/models/form/textarea';

@Component({
  selector: 'app-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTextAreaComponent implements IFormComponent<ITextAreaField> {
  public config: IFormField<ITextAreaField> = new FormField<ITextAreaField>({
    fieldConfig: new TextAreaField(),
  });
  public formConfig: IFormConfig = new FormConfig();
  public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }
}
